import { Badge, Box } from '@mantine/core';

const STATUS_COLORS: Record<string, string> = {
  draft: 'gray',
  confirmed: 'blue',
  processing: 'indigo',
  picking: 'indigo',
  shipped: 'cyan',
  delivered: 'brand',
  completed: 'brand',
  cancelled: 'red',
  paid: 'brand',
  partial: 'yellow',
  overdue: 'red',
  pending: 'yellow',
  open: 'blue',
  active: 'brand',
  // Exception Queue
  acknowledged: 'blue',
  dismissed: 'gray',
  resolved: 'brand',
  warning: 'orange',
  critical: 'red',
  info: 'blue',
  // Accounting
  pending_review: 'yellow',
  auto_approved: 'brand',
  posted: 'brand',
  reversed: 'orange',
  fully_depreciated: 'gray',
  disposed: 'red',
  approved: 'brand',
  rejected: 'red',
  closed: 'blue',
};

interface StatusBadgeProps {
  status: string;
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  const color = STATUS_COLORS[status.toLowerCase()] || 'gray';
  return (
    <Badge
      color={color}
      variant="light"
      size="sm"
      leftSection={
        <Box
          style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            backgroundColor: `var(--mantine-color-${color}-6)`,
          }}
        />
      }
    >
      {status.replace(/_/g, ' ')}
    </Badge>
  );
}
